import React from 'react';

export default function ClaimsPage() {
    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white fw-bold">CLAIMS</h2>
                    </div>
                </div>
                <div className="row content">
                    <div className="col-1"></div>
                    <div className="col-10 shadow bg-white rounded p-5">
                        <p>
                        As your insurance broker, we are committed to protecting your best interests. If you have any questions or need assistance with the instaPol website or your claims, we are here to assist. You may reach us via any of our available contact channels.
			 </p>
                        <p className="fw-bold">Contact Us</p>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">Customer Service Careline</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="tel:+60122606183">+60122606183</a>
                                <p>Operating Hours: Monday to Friday (8:-45 am to 5:45 pm)</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">WhatsApp No.</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a target="_blank" href={"https://api.whatsapp.com/send?phone=0122606183&text=" + process.env.MIX_APP_NAME}>+60122606183</a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">or Scan QR Code to WhatsApp</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <img src="images/whatsapp-qr.png" alt="WhatsApp" width="120"></img>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">Email Us at</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="mailto:insta.admin@my.howdengroup.com">insta.admin@howdengroup.com</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
        </section>
    );
}